import Vue from 'vue'
import { UTILS, UA, COOKIE } from '../utils'
import { API } from '../api'
import { CONFIG } from '../config'
import App from '../../App.vue'
import store from '../store'
import router from '../router'

export default {

    checkPlatForm() {
        var curUrl = window.location.href,
            state = UTILS.getQueryString('state');
        console.log('checkPlatForm-------', curUrl, UA.isWeChat(), UA.isQQ(), UA.isPC())        
        // PC环境
        if(UA.isPC()){
            if(curUrl.indexOf('b.yxdxt.com') != -1 && state == 'web') {
                // 微信授权登录回调过来的地址跳转,第三方登录成功后重定向跳转
                this.thirdLogin(3, function() {
                    window.location.replace(CONFIG.web_url);
                });
            }else if(curUrl.indexOf('qq.yxdxt.com') != -1 && state == 'web') {
                // QQ授权登录回调过来的地址跳转,第三方登录成功后重定向跳转
                this.thirdLogin(6, function() {
                    setTimeout(() => {
                        window.location.replace(CONFIG.web_url);
                    }, 100);
                });
            }else {
                this.checkLogin();
            }
        }else if(UA.isWeChat() || UA.isPcWeChat()) {
            // 微信平台:QQ的链接跳转到微信平台；
            if(curUrl.indexOf('qq') != -1) {
                var path = UTILS.getQueryString('path'),
                    wechatUrl = UTILS.getWechatUrlByCurrentPath(path);
                window.location.href = wechatUrl;
            } else if (curUrl.indexOf('b.yxdxt') != -1 && curUrl.indexOf('famouspediareadweb') == -1) {
                window.location.href = CONFIG.wechat_url;
                // console.log('wechat-------', CONFIG.wechat_url)
            } else {
                this.checkLogin();
            }
        }else if(UA.isQQ()) {
            // QQ平台:微信的链接跳转到QQ平台；
            if(curUrl.indexOf('qq') == -1) {
                var qqUrl = UTILS.getQQUrlByCurrentPath(window.location.pathname);
                window.location.href = qqUrl;
            } else if (curUrl.indexOf('b.yxdxt') != -1 && curUrl.indexOf('famouspediareadweb') == -1) {
                window.location.href = CONFIG.qq_url;
                // console.log('qq-------', CONFIG.qq_url)
            }else {
                this.checkLogin();
            }
        }else {
            this.checkLogin();
        }
    },
    checkLogin() {

        // for test
        // store.state.userData.info = {};
        // store.state.userData.info.uid = 10002;
        // this.renderView();

        // QC.Login.showPopup({
        //     appId: "101875950",
        //     redirectURI: "https://qq.mhwh01.cn/qq?path=record"
        // });

        var me = this, userInfo, userToken;
            userInfo = window.sessionStorage.getItem("H5_Fate_UserInfo");
            userInfo = userInfo != '' ? JSON.parse(userInfo) : null;
            userToken = COOKIE.getCookie('fatetoken') ? COOKIE.getCookie('fatetoken') : null;
            userToken = !userToken && userInfo && userInfo.token ? userInfo.token : userToken;
        // 其他平台用sessionstorage缓存用户登录信息
        if (userToken != null && userToken != 'null') {
            API.checkLogin({
                'token': userToken
            }, function (data) {
                console.log('checkLogin-----success', data)
                store.state.userData = Object.assign({
                    'token': userToken
                }, data);
                me.renderView();
            }, function (data) {
                console.error("checkLogin-----failed", data)
                me.thirdLogin();
            })
        }else{
            me.thirdLogin();
        }
    },
    /**
     * 跳转到授权登录
     */
    thirdLogin(loginType, sucFunc) {
        var me = this;
        var code = UTILS.getQueryString("code");     // 注意：1个code请求登录thirdLogin的接口只能请求1次
        var type = CONFIG.platform == 'wechat' ? 3 : 6;  // 微信3，其他是6
            type = loginType ? loginType : type;
        var params = code ? {
            'code': code,
            'type': type
        } : null;
        if (params) {
            API.thirdLogin(params, function (data) {
                store.state.userData = data;
                console.log('thirdLogin-----授权登录成功', data);
                COOKIE.setCookie('fatetoken', data.token, 5);
                window.sessionStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
                me.renderView();
                if(sucFunc && typeof(sucFunc) == 'function') {
                    sucFunc();
                }
            }, function (data) {
                console.error("thirdLogin-----授权登录失败", data.status_code);
                me.loginFailed();
            });
        } else {
            me.loginFailed();
        }
    },
    /**
     * 第三方登录失败
     */
    loginFailed() {
        if(CONFIG.platform == 'qq') {
            window.location.href = CONFIG.getQQAuthUrl();
        }else if(CONFIG.platform == 'wechat') {
            window.location.href = CONFIG.getWechatAuthUrl();
        }else {
            this.renderView();
        }
    },
    /**
     * 渲染页面
     */
    renderView() {

        // 初始化vue的app
        window.AppFate = new Vue({
            el: '#app',
            template: '<App/>',
            router,
            store,
            components: { App }
        });

        // 横竖屏检查及提示
        this.checkOrientation();
        window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", this.checkOrientation, false);
    },
    checkOrientation() {
        var hoverDiv = document.getElementById('orientOverLay');
        if (window.orientation == 90 || window.orientation == -90) {
            //横屏
            hoverDiv.style.display = 'block';
        } else {
            //竖屏
            hoverDiv.style.display = 'none';
        }
    }
}